import { Component, ElementRef, HostBinding, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import packageJSON from 'src/../package.json';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { ClientsService, SelectedClient } from 'src/app/services/clients/clients.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  private readonly destroy = new Subject<void>();

  readonly clientControl = new FormControl();
  get clientOptions() { return this.clientsService.clientsSubject.value; }

  open = true;
  @ViewChild('appVersion') el: ElementRef;
  @HostBinding('class.close') get close() { return !this.open; }

  loading = false;

  get currentLang(): string { return this.translate.currentLang; }
  readonly langs: string[];

  readonly environment = environment;

  get versionNumber() {
    return packageJSON.version;
  }

  get isCaseCreationEnabled() {
    return this.authService.getUserOrigin() !== 'PLUGIN_STRIPE';
  }

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private clientsService: ClientsService,
  ) {
    this.langs = this.translate.getLangs();
  }

  ngOnInit(): void {
    this.clientsService.selectedClientSubject
      .pipe(takeUntil(this.destroy))
      .subscribe(v => this.clientControl.setValue(v, { emitEvent: false }));

    this.clientControl.valueChanges
      .pipe(takeUntil(this.destroy))
      .subscribe(v => this.clientsService.setSelectedClient(v))
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  toggleOpen() {
    this.open = !this.open;
  }

  selectLang(lang: string): void {
    this.translate.use(lang);
  }

  displayWith(client?: SelectedClient): string {
    return client?.name ?? '';
  }
}
